<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="25" height="24" viewBox="0 0 25 24" fill="none">
    <path
      d="M7.04 5C7.1 5.89 7.25 6.76 7.49 7.59L6.29 8.79C5.88 7.59 5.62 6.32 5.53 5H7.04ZM16.9 17.02C17.75 17.26 18.62 17.41 19.5 17.47V18.96C18.18 18.87 16.91 18.61 15.7 18.21L16.9 17.02ZM8 3H4.5C3.95 3 3.5 3.45 3.5 4C3.5 13.39 11.11 21 20.5 21C21.05 21 21.5 20.55 21.5 20V16.51C21.5 15.96 21.05 15.51 20.5 15.51C19.26 15.51 18.05 15.31 16.93 14.94C16.83 14.9 16.72 14.89 16.62 14.89C16.36 14.89 16.11 14.99 15.91 15.18L13.71 17.38C10.88 15.93 8.56 13.62 7.12 10.79L9.32 8.59C9.6 8.31 9.68 7.92 9.57 7.57C9.2 6.45 9 5.25 9 4C9 3.45 8.55 3 8 3Z"
      fill="url(#paint0_linear_5364_4505)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_5364_4505"
        x1="3.5"
        y1="3"
        x2="21.5612"
        y2="20.9383"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.456596" class="fill-1" />
        <stop offset="1" class="fill-2" />
      </linearGradient>
    </defs>
  </svg>
</template>

<style lang="scss" scoped>
.fill-1 {
  stop-color: #df252a;
}

.fill-2 {
  stop-color: #a20004;
}
</style>
